import React, { Component } from 'react'

import axios from 'axios'
import { OutboundLink } from 'gatsby-plugin-google-analytics'

import Modal from 'react-bootstrap/Modal'

import RegistrationForm from './registration-form'
import SigninForm from './signin-form'
// import SpecificContactForm from '../../../atoms/forms/specific-contact-form/specific-contact-form-button/specific-contact-form-button'
import Stepper from '../../stepper'

import LaunchResetPasswordFormModal from '../reset-password-form/launch-reset-password-form-modal'

const SigninFormModal = class extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errors: false,
      loading: false,
      max_stage: 1,
      notificationShow: false,
      register: false,
      sent: false,
      showErrorNotification: false,
      stage: 0
    }

    this.cancelToken = axios.CancelToken.source()
  }

  componentWillUnmount() {
    try {
      this.cancelToken.cancel()
    } catch (error) {
      console.log(error)
    }
  }

  showNotification = () => {
    this.setState({ notificationShow: true })
  }

  hideNotification = () => {
    this.setState({ notificationShow: false })
  }

  showErrorNotification = () => {
    this.setState({ showErrorNotification: true })
  }

  hideErrorNotification = () => {
    this.setState({ showErrorNotification: false })
  }

  render() {
    return (
      <Modal
        // {...this.props}
        show={this.props.show}
        onHide={this.props.onHide}
        size="lg"
        aria-labelledby="signin-form"
        centered
      >
        <Stepper
          setStage={(stage) => {
            stage === 0
              ?
              this.setState({ stage: stage, register: false })
              :
              this.setState({ stage: stage, register: true })
          }}
          setMaxStage={(max_stage) => this.setState({ max_stage })}
          stage={this.state.stage}
          max_stage={this.state.max_stage}
          // number_of_steps={2}  // Remove "Register" tab
          number_of_steps={1}
          signed_in={this.props.signed_in}
          steps={[["Sign in", "fa-sign-in-alt"]]}
          // steps={[["Sign in", "fa-sign-in-alt"], ["Register", "fa-user-plus"]]}  // Remove "Register" tab
          no_checks={true}
        />
        <Modal.Body>
          {(!this.state.register || this.state.stage === 0) &&
            <SigninForm setSignedIn={this.props.setSignedIn} />
          }
          {/*(this.state.register || this.state.stage === 1) &&
            <RegistrationForm setSignedIn={this.props.setSignedIn} />  // Remove "Register" tab
        */}
        </Modal.Body>
        <div className="p-3">
          <hr />
          <p className="w-100 mb-2">Need a sign-in code or having trouble signing in? <OutboundLink href="https://bscs.org/resources/educator-resource-center/request-a-medical-mystery-registration-code/" target="_blank" rel="noopener noreferrer"><b>Request a sign-in code&nbsp;<sup><i style={{ fontSize: '.65rem' }} className="fas fa-external-link-alt"></i></sup></b></OutboundLink></p>

          {/* <div className="w-100" style={{ fontSize: '.9rem' }}> // Remove Password Reset
            <p className="w-100 mb-2">Forgot your password? Please <OutboundLink href="https://bscs.org/contact-form/?to=Betty%20Stennett&recipient_email=bstennett@bscs.org" target="_blank" rel="noopener noreferrer">contact BSCS&nbsp;<sup><i style={{ fontSize: '.65rem' }} className="fas fa-external-link-alt"></i></sup></OutboundLink> and request a password reset.</p>
            <LaunchResetPasswordFormModal>
              Forgot password?
            </LaunchResetPasswordFormModal>
          </div> */}
        </div>
      </Modal>
    )
  }
}

export default SigninFormModal
